module.exports = __webpack_public_path__ + "static/media/Kunstat.4d771c76.jpg";